import React from 'react'
import ProspectingForm from '../ProspectingForm'

const CourseApplication = ({data}) => {
  return (
    <div className='courseAppContainer'>
        <div  className='courseAppContentOne'>
            <h2 className='courseAppContentOnehtwo'>{data}</h2> 
            <div>
              <ul className='courseAppContentOneUl'>
                <li>Unlimited Support</li>
                <li>Real life Projects</li>
                <li>Flexible Schedules</li>
                <li>Installment Payment options</li>
                <li>Resume Support untill Job Placement</li>
                <li>Recorded Videos</li>
              </ul> 
            </div>
            <button onClick={()=>window.location.reload()} type='button'>&larr; Go back</button>
        </div>
        <div  className='courseAppContenttwo'>
          <ProspectingForm data={data}/>
        </div>

    </div>
  )
}

export default CourseApplication